exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-bar[data-v-4887bd12]{padding-bottom:1rem}[data-v-4887bd12] .iconfont{font-size:12px}.top-bar[data-v-4887bd12]{align-items:center;justify-content:space-between;padding-bottom:1rem;color:#504e4e}.title[data-v-4887bd12]{font-size:14px;font-weight:600}[data-v-4887bd12] .van-grid-item__content{padding:4px;background-color:#f2f2f2;border:1px solid #dedede}[data-v-4887bd12] .van-grid-item__text{font-family:PingFangSC-Regular;font-size:12px;color:#7d7d7d}.active[data-v-4887bd12] .van-grid-item__text{color:#c52a1a}.active[data-v-4887bd12] .van-grid-item__content{background-color:#f7c8c4 40%;border:1px solid #c52a1a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4887bd12","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/SearchTypeBar.vue
// module id = 821
// module chunks = 0